
const formatToIndianNumberSystem = (value) => {
  if (value === null || value === undefined) return value; // Handle null or undefined values
  if (isNaN(value)) return value; // Return the value if it's not a number

  // Convert the value to a string
  const numberString = value.toString();
  const [wholeNumber, decimalPart] = numberString.split(".");

  // Handle whole number part
  let lastThreeDigits = wholeNumber.slice(-3);
  const otherDigits = wholeNumber.slice(0, -3);
  let formattedWholeNumber;

  if (otherDigits) {
    formattedWholeNumber =
      otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThreeDigits;
  } else {
    formattedWholeNumber = lastThreeDigits;
  }

  // Combine whole number with decimal part, if it exists
  return decimalPart
    ? formattedWholeNumber + "." + decimalPart
    : formattedWholeNumber;
};

// Export the formatting function
export { formatToIndianNumberSystem };
